module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/filetree-level-bc7c0bae01f0296f90e9163e02dd9b11.svg";